// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"2c163b17","970":"e4956db8"}[chunkId] + ".chunk.js";
};